module.exports = __webpack_public_path__ + "static/img/1483_phase_function_Paper_PointsHejduk_Prediction.fc243db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1483_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7kZ5
// module chunks = 0